import { Navigate } from "react-router-dom";
import { useProject } from "../contexts/ProjectContext";

/**
 * OwnerRoute component that protects routes requiring owner permissions
 * Redirects non-owners to 404 page
 */
const OwnerRoute = ({ children }) => {
  const { currentUserRole } = useProject();

  // While loading, show a loading state instead of redirecting
  if (currentUserRole === null) {
    return <div>Loading...</div>;
  }

  // Only allow access if user has owner role
  if (currentUserRole !== "owner") {
    return <Navigate to="/404" replace />;
  }

  return children;
};

export default OwnerRoute;
